import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./img_and_css/style.css";
import "./img_and_css/default.css";
import "./img_and_css/plugins/bootstrap.min.css";
import "./img_and_css/plugins/fontawesome.min.css";
import "./img_and_css/plugins/slick.css";
import "./img_and_css/plugins/animate.css";
import "./img_and_css/plugins/swiper.min.css";
import "./img_and_css/plugins/odometer.css";

const footerStyle = {
  backgroundColor: "#f1f1f1", // Adjust the background color as needed
  textAlign: "center",
  padding: "10px 0",
  boxShadow: "0 -2px 5px rgba(0,0,0,0.1)", // Optional: Add a shadow for better visibility
};

const Footer = () => {
  useEffect(() => {
    const scripts = [
      "../assets/js/plugins/jquery-3.6.0.min.js",
      "../assets/js/plugins/isotope.pkg.min.js",
      "../assets/js/plugins/jquery.slick.min.js",
      "../assets/js/plugins/odometer.js",
      "../assets/js/plugins/ripples.min.js",
      "../assets/js/plugins/wow.min.js",
      "../assets/js/plugins/swiper.min.js",
      "../assets/js/main.js",
    ];

    scripts.forEach((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    });
  }, []);

  return (
    <footer
      className="cs_footer background-filled text-white"
      style={{
        ...footerStyle,
        backgroundImage: "url('../img_and_css/img/footer_bg.jpeg')",
      }}
    >
      <div className="container">
        <div className="cs_footer_top d-flex justify-content-between align-items-start align-items-md-center cs_pt_46 cs_pb_46 cs_column_gap_15 cs_row_gap_15 flex-md-row flex-column">
          <div className="cs_footer_contact_info">
            <div
              className="cs_footer_logo wow zoomIn"
              data-wow-duration="0.8s"
              data-wow-delay="0.2s"
            >
              <img src="../img_and_css/img/logo.png" alt="InSight ABA Notes" />
            </div>
          </div>

          <div className="cs_footer_contact_info">
            <h3 className="text-accent fw-normal cs_mb_4 cs_fs_16 cs_lh_lg">
              Send Email
            </h3>
            <h2 className="text-white fw-medium m-0 cs_fs_22">
              <a href="mailto:Support@insightabanotes.com">
                Support@insightabanotes.com
              </a>
            </h2>
          </div>
        </div>
        <div className="cs_footer_main cs_pt_30 cs_pb_30">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_footer_item cs_pt_20 cs_pb_20">
                <div className="cs_text_widget">
                  <p>
                    Applied Behavior Analysis (ABA) notes are detailed records
                    used by behavior analysts to track and analyze the progress
                    of clients undergoing ABA therapy.
                  </p>
                </div>
                <div className="cs_social_btns d-flex flex-wrap cs_column_gap_15 cs_row_gap_15 cs_transition_5">
                  <a
                    href="https://www.facebook.com/insightabanotes/"
                    className="d-flex align-items-center justify-content-center cs_height_35 cs_width_35 text-white rounded-circle" target="_blank"
                  >
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://x.com/insightabanotes"
                    className="d-flex align-items-center justify-content-center cs_height_35 cs_width_35 text-white rounded-circle" target="_blank"
                  >
                    <i className="fa-brand fa-x"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/insight-aba-notes-b92840348/"
                    className="d-flex align-items-center justify-content-center cs_height_35 cs_width_35 text-white rounded-circle" target="_blank"
                  >
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/@InSightABANotes"
                    className="d-flex align-items-center justify-content-center cs_height_35 cs_width_35 text-white rounded-circle" target="_blank"
                  >
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 offset-lg-1">
              <div className="cs_footer_item cs_pt_20 cs_pb_20">
                <h2 className="cs_widget_title text-white cs_fs_22 cs_mb_22">
                  Explore
                </h2>
                <p>
                  <Link to="/about-us">About us</Link>
                </p>
                <p>
                  <Link to="/privacypolicy">Privacy Policy</Link>
                </p>
                <p>
                  <Link to="/termsandconditions">Terms & Conditions</Link>
                </p>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cs_footer_item cs_pt_20 cs_pb_20">
                <div className="cs_newsletter cs_style_1">
                  <h2 className="cs_widget_title text-white cs_fs_22 cs_mb_22">
                    Explore
                  </h2>
                  <p>
                    <Link to="/demographics">Demo</Link>
                  </p>
                  <p>
                    <Link to="/services">Services</Link>
                  </p>
                  <p>
                    <Link to="/contact">Contact</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_copyright text-center cs_fs_124 cs_lh_lg cs_pt_36 cs_pb_36">
        <div className="container">
          <p className="m-0">
            Copyright © 2025 <Link to="/index.html">InSight ABA NOTES</Link>.
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
